import React from "react";

function SvgIcMapPoi022(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M7 9a1 1 0 011 1v7h16a1 1 0 012 0v6h-2v-2H8v2H6V10a1 1 0 011-1zm7.018 4h7.601a1.43 1.43 0 011.423 1.291l.006.138V16h-9.03v-3h7.601zm-3.294-.993c.96 0 1.737 1.09 1.737 1.924 0 .68-.524.974-1.239 1.059-.3-.571-.86-1.06-1.5-1.06-.22 0-.428.04-.622.104a1.322 1.322 0 01-.112-.52c0-.833.777-1.507 1.736-1.507z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi022;
